export default {"src":"/_next/static/media/iron.ac7fe2c7.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};